import { render, staticRenderFns } from "./HumusBalance.vue?vue&type=template&id=42c3030f&lang=html&"
import script from "./HumusBalance.vue?vue&type=script&lang=js&"
export * from "./HumusBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports